@if (
  {
    row: columnData | async,
    adata: additionData$ | async,
  };
  as $
) {
  @if ($.row[$.adata.keyName]) {
    <span
      >{{ $.adata.pre ? $.adata.pre : '' }}{{ $.row[$.adata.keyName]
      }}{{ $.adata.post ? $.adata.post : '' }}</span
    >
  } @else {
    -
  }
}
